<template>
  <drag-dialog
    :visible.sync="visible"
    :title="`${activeId ? '编辑' : '新增'}角色信息`"
    width="600px"
    height="400px"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset('editForm')"
  >
    <el-form v-loading="detailLoading" :model="editForm" :rules="rules" ref="editForm" label-width="120px">
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="24">
          <el-form-item label="角色名称" prop="name">
            <el-input v-model.trim="editForm.name" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="角色编码" prop="code">
            <el-input v-model="editForm.code" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="角色描述" prop="remark">
            <el-input type="textarea" v-model="editForm.remark" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="排序" prop="sort">
            <el-input-number v-model="editForm.sort" :min="0" :max="1000"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否可用" prop="deleted">
            <el-switch
              v-model="editForm.deleted"
              :active-value="0"
              :inactive-value="1"
              active-text="启用"
              inactive-text="禁用"
            ></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确 认</el-button>
    </template>
  </drag-dialog>
</template>

<script>
import { getRole, saveRole } from '@/api/user';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      detailLoading: false,
      editForm: {
        sort: 0,
        deleted: 0
      },
      rules: {
        name: [{ required: true, message: '请输入角色名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入角色编码', trigger: 'blur' }]
      },
      submitLoading: false
    };
  },
  computed: {},
  watch: {
    visible(val) {
      if (val && this.activeId) {
        this.getRole();
      }
    }
  },
  methods: {
    async getRole() {
      this.detailLoading = true;

      const data = await getRole(this.activeId);
      this.editForm = { ...data };

      this.detailLoading = false;
    },
    handleSubmit() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          this.submitLoading = true;
          try {
            await saveRole(this.editForm);

            this.$emit('refresh');
            this.$emit('update:visible', false);
            this.$message.success('提交成功!');
          } finally {
            this.submitLoading = false;
          }
        }
      });
    }
  },
  created() {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}

.el-button--mini.is-circle {
  padding: 5px;
}
</style>
